import { inject, Injectable } from '@angular/core';
import { FeatureSettings } from '@backModels/FeatureSettings';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigApi {
  private readonly api = inject(ApiService);

  getFeatures(): Promise<FeatureSettings> {
    return this.api.get<FeatureSettings>('config/features');
  }
}
